// extracted by mini-css-extract-plugin
export var arrow = "_2p-6";
export var changeItem = "_2p-3";
export var changesHeader = "_2p-1";
export var changesList = "_2p-2";
export var container = "_2p-0";
export var pathLabel = "_2p-4";
export var value = "_2p-7";
export var valuesContainer = "_2p-5";